// Actions
export const DOWNLOAD_FETCH  = '[Download] Fetch'

// Mutations
export const DOWNLOAD_META   = '[Download] meta'
export const DOWNLOAD_OBTAIN = '[Download] obtain'
export const DOWNLOAD_CLEAR  = '[Download] clear'
export const DOWNLOAD_SET_LOADING = '[Download] set loading'
